import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/**
 * Wraps routes that require an authenticated user. Renders:
 *   - the child <Outlet/> when signed in,
 *   - a silent loader while Firebase is still checking onAuthStateChanged,
 *   - a redirect to /login (preserving the attempted URL) otherwise.
 */
export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg text-fg-subtle text-[13px]">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}
